import { Stack } from "@mui/material";
import React from "react";
import Image from "next/image";
import assest from "@/json/assest";

const NoDataFound = () => {
  return (
    <div>
      {" "}
      <Stack flex={1} direction="row" justifyContent="center">
        <Image src={assest.nodatafound} width={300} height={300} alt="" />
      </Stack>
    </div>
  );
};

export default NoDataFound;
